import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/axiosInstance";
import { ProfileTypes } from "../../../interfaces/Subscription";
import { TODOS } from "../../../utils/const";

const { REACT_APP_API_PATH } = process.env;

export const getProfileTypes = createAsyncThunk(
    'subscription/getProfiles',
    async (_, thunkAPI) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/admin/mensajeria/profile-types`)
            const data = response.data.data.filter((item: ProfileTypes) => item.nombre.toLocaleLowerCase() !== TODOS)

            return {
                profile: data,
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const postUnsubscribe = createAsyncThunk(
    'subscription/unsubscribe',
    async (id: number, thunkAPI) => {
        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_API_PATH}/public/subscriptions/unsubscribe`,
                { contacto_id: id }
            )

            const removed = response.data?.data?.removed ?? false

            return { unsubscribe: removed }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.response?.data || { message: 'Unexpected error' }
            )
        }
    }
)